import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/CheckIn';
import './CheckIn.css';
import { Button, FormGroup, FormControl, HelpBlock, Checkbox, Modal } from 'react-bootstrap';
import { RingLoader } from 'react-spinners';
import fetchClient from '../common/FetchClient';
import moment from 'moment'
import 'moment-timezone'
import axios from 'axios';
import { adalApiFetch, getToken, authContext } from '../../adalConfig';

const getLocation = () => {
    const geolocation = navigator.geolocation;

    return new Promise((resolve, reject) => {
        if (!geolocation) {
            reject(new Error('Not Supported'));
        }

        geolocation.getCurrentPosition((position) => {
            resolve(position);
        }, () => {
            reject(new Error('Permission denied'));
        });
    });
};

class CheckIn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checkIns: localStorage.getItem('checkIns') ? JSON.parse(localStorage.getItem('checkIns')) : [],
            showProspect: false,
            tripStarted: false,
            tripName: '',
            prospectName: '',
            startOdometer: 0,
            endOdometer: 0,
            showError: false,
            errorMessage: '',
            mileageConfirmation: '',
            showMileageConfirmation: false,
            isLoading: false,
            isSubmitting: false,
            auth: authContext.getCachedUser(),
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleProspect = this.toggleProspect.bind(this);
        this.handleTripNameChange = this.handleTripNameChange.bind(this);
        this.startTrip = this.startTrip.bind(this);
        this.handleStartOdometerChange = this.handleStartOdometerChange.bind(this);
        this.handleEndOdometerLeave = this.handleEndOdometerLeave.bind(this);
        this.handleEndOdometerChange = this.handleEndOdometerChange.bind(this)
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleAcceptMileage = this.handleAcceptMileage.bind(this);
        this.setNewProspect = this.setNewProspect.bind(this);
        this.addCheckIn = this.addCheckIn.bind(this);
        this.setStartOrStopTrip = this.setStartOrStopTrip.bind(this);
        this.selectFocus = this.selectFocus.bind(this);
    }

    componentWillMount() {
        // This method runs when the component is first added to the page
        this.props.getCheckInHistory();

        if (localStorage.getItem('tripStarted') === null) {
            localStorage.setItem('tripStarted', false);
        }

        var tripStarted = localStorage.getItem('tripStarted');

        if (tripStarted === "true") {
            tripStarted = true;
        } else if (tripStarted === "false") {
            tripStarted = false;
        }

        var tripName = localStorage.getItem('currentTripName');
        if (tripName === null || tripName === '') {
            tripName = this.getTripNamePrefix();
        }

        this.setState({ tripName: tripName });
        this.setState({ tripStarted: tripStarted });
        this.setState({ startOdometer: Number(localStorage.getItem('startOdometer')) });
        this.setState({ endOdometer: Number(localStorage.getItem('endOdometer')) });

        this.props.history.push('/check-in/');
    }

    componentWillReceiveProps(nextProps) {
        
    }

    selectFocus(e) {
        e.target.select();
    }

    handleClose() {
        this.setState({ showError: false });
        this.setState({ showMileageConfirmation: false });
    }

    handleShow() {
        this.setState({ showError: true });
    }

    addCheckIn() {
        try {
            var that = this;
            var latitude = '';
            var longitude = '';

            if ((!that.state.newProspectName || that.state.newProspectName === '') && (!localStorage.getItem('customer') || localStorage.getItem('customer') === '')) {
                that.setState({ errorMessage: 'You must select a customer or enter a prospect name to check-in. ' }
                    , that.handleShow());
                return;
            }

            this.setState({ isLoading: true });

            let location = getLocation().then(function (result) {
                console.log(result.coords);

                latitude = result.coords.latitude;
                longitude = result.coords.longitude;
                var checkInTime = that.getDateFormatted(new Date(), true);

                var customer = '';
                if (localStorage.getItem('customer') === '' || (that.state.newProspectName && that.state.newProspectName !== '')) {
                    customer = '';
                } else {
                    customer = localStorage.getItem('customer');
                }

                var checkIn = {
                    CheckInTime: checkInTime,
                    Latitude: latitude,
                    Longitude: longitude,
                    Customer: customer,
                    Prospect: that.state.newProspectName,
                    CustomerName: localStorage.getItem('customerName')
                };

                console.log(checkIn);

                var checkIns = that.state.checkIns;
                checkIns.push(checkIn);

                that.setState({ checkIns: checkIns }, localStorage.setItem('checkIns', JSON.stringify(checkIns)));
                that.setState({ newProspectName: '' });
            });
        } catch (error) {
            that.setState({ errorMessage: 'Error contacting app service. Check internet connection and app login. ' }
                , that.handleShow());

        } finally {
            that.setState({ isLoading: false });
        }
    }

    setStartOrStopTrip(isEndOfTrip) {
        var that = this;

        if (isEndOfTrip === true && that.state.startOdometer > that.state.endOdometer) {
            that.setState({ errorMessage: 'The end odometer must be greater than the start odometer. ' }
                , that.handleShow());
        } else if (isEndOfTrip === true && (that.state.endOdometer - that.state.startOdometer) > 500) {
            that.setState({ mileageConfirmation: 'Your trip is greater than 500 miles long, accept? ' }
                , this.setState({ showMileageConfirmation: true }));
        } else {
            that.doStartOrStopTrip(isEndOfTrip);
        }
    }


    submitCheckIn() {
        var checkInData = {
            StartTime: localStorage.getItem('tripStartTime'),
            EndTime: localStorage.getItem('tripEndTime'),
            StartOdometer: localStorage.getItem('startOdometer'),
            EndOdometer: localStorage.getItem('endOdometer'),
            StartLatitude: localStorage.getItem('startLatitude'),
            StartLongitude: localStorage.getItem('startLongitude'),
            StopLatitude: localStorage.getItem('stopLatitude'),
            StopLongitude: localStorage.getItem('stopLongitude'),
            TripName: localStorage.getItem('currentTripName'),
            CheckInDetails: localStorage.getItem('checkIns')
        };

        var that = this;
        const url = `/api/SalesCheckIn/SubmitCheckIn`;

        try {
            const defaultOptions = {
                method: 'get',
                timeout: 10000,
                headers: {
                    'Content-Type': 'application/json',
                }
            };

            // Create instance
            let instance = axios.create(defaultOptions);
            instance.defaults.timeout = 10000;

            // Set the AUTH token for any request
            instance.interceptors.request.use(function (config) {
                const token = getToken();
                config.headers.Authorization = token ? `Bearer ${token}` : '';
                return config;
            });

            instance.get(url, {
                params: {
                    azureToken: '',
                    checkInData: checkInData,

                }
            }).then(function (resp) {
                console.log(resp.data);
                if (resp.data === "1") {

                    // delete all localStorage items relevant to checkIn
                    localStorage.removeItem('stopLatitude');
                    localStorage.removeItem('stopLatitude');
                    localStorage.removeItem('startLatitude');
                    localStorage.removeItem('startLatitude');
                    localStorage.removeItem('tripEndTime');
                    localStorage.removeItem('tripStartTime');
                    localStorage.removeItem('checkIns');
                    localStorage.removeItem('currentTripName');
                    localStorage.removeItem('startOdometer');
                    localStorage.removeItem('endOdometer');
                    localStorage.removeItem('stopLongitude');
                    localStorage.removeItem('stopLatitude');

                    that.setState({ tripStarted: false });

                    localStorage.setItem('tripStarted', false);

                    that.setState({ endOdometer: 0 });
                    that.setState({ startOdometer: 0 });
                    that.setState({ tripName: that.getTripNamePrefix() });
                    that.setState({ checkIns: [] });

                    that.setState({ isSubmitting: false });

                    that.setState({ errorMessage: 'Trip submitted. ' }
                        , that.handleShow());
                } else {
                    console.log('Unknown response');
                    that.setState({ isSubmitting: false });

                    that.setState({ errorMessage: 'Error unknown response received from check-in. Please contact your administrator. ' }
                        , that.handleShow());
                }
            }).catch(error => {
                console.log('Error contacting server');
                that.setState({ isSubmitting: false });

                that.setState({ errorMessage: 'Error contacting app service. Check internet connection and app login. ' }
                    , that.handleShow()).then(window.location.reload());
            });
        } catch (error) {
            
        } finally {
            if (localStorage.getItem('tripStartTime')) {
                // check-in failed can throw an error here later.
                // double check if clause to make sure it's working
            }
        }
    }

    doStartOrStopTrip(isEndOfTrip) {
        var that = this;
        var latitude = '';
        var longitude = '';

        let location = getLocation().then(function (result) {
            latitude = result.coords.latitude;
            longitude = result.coords.longitude;

            if (isEndOfTrip === true) {
                that.setState({ isSubmitting: true });
                localStorage.setItem('stopLatitude', latitude);
                localStorage.setItem('stopLongitude', longitude);
                localStorage.setItem('tripEndTime', that.getDateFormatted(new Date(), true));

                that.submitCheckIn();
            } else if (isEndOfTrip === false) {
                that.setState({ tripStarted: true });

                localStorage.setItem('startLatitude', latitude);
                localStorage.setItem('startLongitude', longitude);
                localStorage.setItem('tripStarted', true);
                localStorage.setItem('tripStartTime', that.getDateFormatted(moment(), true));
                localStorage.setItem('currentTripName', that.state.tripName);
            }

        });
    }

    handleAcceptMileage() {
        // TODO: disable accept button
        // here...
        this.doStartOrStopTrip(true);
    }

    handleSubmit(event) {
        event.preventDefault();

        var endOdometer = this.state.endOdometer;

        if (Number(endOdometer) === 0) {
            this.setState({ errorMessage: 'You must enter an end odometer value to end a trip. ' }
                , this.handleShow());
        } else {
            this.setStartOrStopTrip(true);
        }
    }

    toggleProspect(e) {
        const currentState = this.state.showProspect;
        this.setState({ showProspect: !currentState });
    }

    handleTripNameChange(e) {
        var tripName = e.target.value;
        
        if (!tripName.startsWith(this.getTripNamePrefix())) {
            tripName = this.getTripNamePrefix();
        }
        e.target.value = tripName;

        this.setState({ tripName: tripName });
    }

    getTripNamePrefix() {
        return this.getDateFormatted(new Date(), false) + ' ' + this.state.auth.userName.replace('@empirepaper.com', '') + ' - ';
    }

    setNewProspect(e) {
        this.setState({ newProspectName: e.target.value });
    }

    getDateFormatted(date, includeTime) {
        let now = moment(date);

        if (includeTime) {
            return now.format('MM/DD/YYYY, hh:mm:ss a');
        } else {
            return now.format('MM/DD/YYYY');
        }
    }

    handleStartOdometerChange(e) {
        console.log('startOdom', e.target.value);
        this.setState({ startOdometer: e.target.value });

        localStorage.setItem('startOdometer', e.target.value);
    }

    handleEndOdometerChange(e) {
        this.setState({ endOdometer: e.target.value });
    }

    handleStartOdometerLeave(e) {
        var odomValue = e.target.value;

        odomValue = this.getValidOdometerValue(odomValue);

        if (odomValue > this.state.endOdometer) {
            e.target.value = this.state.EndOdometer;
            this.setState({ errorMessage: 'The start odometer must be less than the end odometer. ' }
                , this.handleShow());
        } else {
            e.target.value = odomValue;

            this.setState({ startOdometer: odomValue });
            localStorage.setItem('startOdometer', odomValue);
        }
    }

    handleEndOdometerLeave(e) {
        var odomValue = e.target.value;

        odomValue = this.getValidOdometerValue(odomValue);

        if (odomValue < this.state.startOdometer) {
            e.target.value = this.state.startOdometer;
            this.setState({ errorMessage: 'The end odometer must be greater than the start odometer. ' }
                , this.handleShow());
        } else {
            e.target.value = odomValue;

            this.setState({ endOdometer: odomValue });
            localStorage.setItem('endOdometer', odomValue);
        }
    }

    getValidOdometerValue(odomValue) {
        if (odomValue !== '') {
            odomValue = Number(odomValue);

            return ~~odomValue;
        } else {
            return 0;
        }
    }

    startTrip(e) {
        var startOdometer = this.state.startOdometer;

        if (Number(startOdometer) === 0) {
            this.setState({ errorMessage: 'You must enter a start odometer value to start a trip. ' }
                , this.handleShow());
            
        } else {
            this.setStartOrStopTrip(false);
        }
    }

    render() {
        return (
            <div>
                <h1>Customer Check-in</h1>
                <br />
                
                <form onSubmit={this.handleSubmit}>
                    <FormGroup
                        controlId="checkInForm"
                    >
                        <div>
                            <HelpBlock>Trip Name</HelpBlock>

                            <FormControl
                                type="text"
                                className="trip-name"
                                value={this.state.tripName}
                                onChange={this.handleTripNameChange}
                            />
                            

                            <HelpBlock>Start Odometer</HelpBlock>
                            
                            <FormControl
                                type="number"
                                onChange={this.handleStartOdometerChange}
                                min="1"
                                step="1"
                                pattern="\d*"
                                value={this.state.startOdometer}
                                className="checkin-odometer inline"
                            />

                            <br />
                            <Button
                                disabled={this.state.tripStarted}
                                onClick={this.startTrip}
                            >Start</Button>
                            
                            <br />
                            <br />
                            <Checkbox
                                inline
                                disabled={!this.state.tripStarted}
                                onChange={this.toggleProspect}
                            >New Prospect</Checkbox>

                            <HelpBlock
                                className={!this.state.showProspect ? 'checkin-cust-input' : 'hidden'}
                            >Selected Customer</HelpBlock>
                            
                            <FormControl
                                className={this.state.showProspect ? 'checkin-cust-input' : 'hidden'}
                                type="text"
                                value={this.state.newProspectName}
                                onChange={this.setNewProspect}
                                placeholder="Company name..."
                            />
                            <FormControl
                                className={!this.state.showProspect ? 'checkin-cust-input' : 'hidden'}
                                type="text"
                                readOnly={true}
                                placeholder={localStorage.getItem('customerName')}
                            />
                            <FormGroup
                                className="checkin-buttons"
                            >
                                <Button bsStyle="default"
                                    disabled={this.state.isLoading}
                                    style={{ marginLeft: '-200px', position: 'absolute' }}
                                    className={!this.state.showProspect ? '' : 'hidden'}
                                    onClick={() => window.open('/customer-search', '_self')}
                                >
                                    Change
                                </Button>
                                
                                <Button bsStyle="success"
                                    disabled={this.state.isLoading}
                                    onClick={this.addCheckIn}
                                    disabled={!this.state.tripStarted}
                                >
                                    Check-in
                                </Button>
                                <br />
                            </FormGroup>

                            <div className={this.state.isLoading ? '' : 'hidden'}>
                                <RingLoader
                                    sizeUnit={"px"}
                                    size={23}
                                    color={'#4d721e'}
                                    loading={this.state.isLoading}
                                />
                                <p style={{
                                    marginLeft: '30px',
                                    marginTop: '-23px',
                                    fontSize: '16px'
                                }}>Adding Check-in...</p>
                                
                                <br />
                            </div>

                            <HelpBlock>End Odometer</HelpBlock>
                            <FormControl
                                type="number"
                                min="1"
                                step="1"
                                pattern="\d*"
                                value={this.state.endOdometer}
                                onChange={this.handleEndOdometerChange}
                                onBlur={this.handleEndOdometerLeave}
                                disabled={!this.state.tripStarted}
                                className="checkin-odometer inline"
                            /> &nbsp;
                            <Button
                                disabled={!this.state.tripStarted
                                    || this.state.isLoading
                                    || this.state.isSubmitting}
                                type="submit"
                            >Stop</Button>

                            <br />
                            <div className={this.state.isSubmitting ? '' : 'hidden'}>
                                <RingLoader
                                    sizeUnit={"px"}
                                    size={23}
                                    color={'#4d721e'}
                                    loading={this.state.isSubmitting}
                                />
                                <p style={{
                                    marginLeft: '30px',
                                    marginTop: '-23px',
                                    fontSize: '16px'
                                }}>Submitting Trip...</p>

                                <br />
                            </div>

                        </div>

                    </FormGroup>
                </form>

                <div id="check-in-list"
                    style={{ marginBottom: '30px' }}
                    className={this.state.tripStarted === true ? '' : 'hidden'}>
                    <hr />
                    <h3>Check-in List</h3>
                    <p style={{ display: 'inline' }}>Start: 
                        <b> {this.getDateFormatted(localStorage.getItem('tripStartTime') ? localStorage.getItem('tripStartTime') : moment(), true)}</b>
                    </p>
                    {
                        this.state.checkIns.map(checkIn => 
                            <div>
                                <p style={{ display: 'inline' }}>
                                    <b>{this.getDateFormatted(checkIn.CheckInTime, true)}
                                        ,&nbsp;{checkIn.Customer ? checkIn.Customer + ', ' + checkIn.CustomerName : 'Prospect, ' + checkIn.Prospect}</b>
                                </p>
                                <br />
                            </div>
                        )
                    }
                    <br />
                </div>

                <Modal show={this.state.showError} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.errorMessage === 'Trip submitted. ' ? 'Success' : 'Error'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h4>{this.state.errorMessage + ''}</h4>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleClose}>OK</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showMileageConfirmation} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h4>{this.state.mileageConfirmation + 'Hit OK to accept or cancel to close this window.'}</h4>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleAcceptMileage}>Accept</Button>
                        <Button onClick={this.handleClose}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default connect(
    state => state.checkIn,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(CheckIn);


// WEBPACK FOOTER //
// ./src/components/sales/CheckIn.js